<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
            v-model="searchForm.fusername"
            placeholder="代理名称"
            style="width: 100px;"
          />
        </el-form-item>

        <el-form-item
        >
          <el-input
                  v-model="searchForm.userName"
                  placeholder="商户名"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
        >
          <el-select
                  class="filter-item"
                  v-model="searchForm.pass"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in bsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
        >
          <el-select
                  class="filter-item"
                  v-model="searchForm.pingkey"
                  placeholder="乐刷进件状态"
                  width="50"
          >
            <el-option
                    v-for="item in lsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
        >
          <el-select
                  class="filter-item"
                  v-model="searchForm.one_type_new"
                  placeholder="商家类型"
                  width="50"
          >
            <el-option
                    v-for="item in zjOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
        >
          <el-input
                  v-model="searchForm.oper_name"
                  placeholder="审核人"
                  style="width: 100px;"
          />
        </el-form-item>

        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="进件开始日期"
                  end-placeholder="进件结束日期"    width="150">

          </el-date-picker>

        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="商户名"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>





      <el-table-column
        label="商户账号"
        prop="userCode"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.userCode}}
        </template>
      </el-table-column>
      <el-table-column
              label="商家类型"
              prop="pass"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.one_type=='1'">
            个体工商户
          </div>
          <div v-else-if="scope.row.one_type=='2'">
            企业
          </div>
          <div v-else-if="scope.row.one_type=='300'">
            小微商户
          </div>
        </template>
      </el-table-column>
     <!-- <el-table-column
            label="签约状态"
            prop="pass"
            sortable="custom"
            :show-overflow-tooltip="true"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.pass=='0'">
          已签约
        </div>
        <div v-else-if="scope.row.pass=='1'  || scope.row.pass=='3'">
          未开通
        </div>
        <div v-else-if="scope.row.pass=='2'">
          待审核
        </div>
        <div v-else-if="scope.row.pass=='5'">
          <div v-if="scope.row.parts_no==''">
            未微信进件
          </div>
          <div v-else-if="scope.row.parts_no!=''">
            已提交微信进件、待微信审核
          </div>
        </div>
      </template>
    </el-table-column>-->

      <el-table-column
              label="乐刷签约状态"
              prop="pingkey"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
            <div v-if="scope.row.pingkey==''">
              未进件
            </div>
            <div v-else-if="scope.row.pingkey!=''">
              <div v-if="scope.row.fws_type=='1'">
              进件成功
            </div>
            <div v-else-if="scope.row.fws_type=='0'">
              进件驳回
            </div>
            <div v-else-if="scope.row.fws_type=='2'">
              进件审核中
            </div>
          </div>


        </template>
      </el-table-column>

      <el-table-column
              label="乐刷编号"
              prop="pingkey"
              sortable="custom"
              :show-overflow-tooltip="true"
              width="90"
      >
        <template slot-scope="scope">
          {{scope.row.pingkey}}
        </template>
      </el-table-column>
      <el-table-column
              label="商家折扣"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.gyj_discount=='10'">
         不让折扣
          </div>
          <div v-else>
            {{scope.row.gyj_discount}}
          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="备注"
              prop="pass"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.desc_content}}
        </template>
      </el-table-column>
      <el-table-column
              label="上级代理"
              prop="pass"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
              {{scope.row.pagentid}}
        </template>
      </el-table-column>
      <el-table-column
              label="进件时间"
              prop="jj_dates"
              sortable="custom"
              :show-overflow-tooltip="true"
              width="150"
      >
        <template slot-scope="scope">
          {{scope.row.jj_dates}}
        </template>
      </el-table-column>
      <el-table-column
              label="审核人"
              prop="app_auth_token"
              sortable="custom"
              :show-overflow-tooltip="true"
              width="80"
      >
        <template slot-scope="scope">
          {{scope.row.app_auth_token}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="350"
      >
          <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"   v-if="scope.row.pass=='2' || scope.row.pass=='3' "   @click="openEditForm(scope.row)">进件</el-button>
            <el-button type="primary" plain  size="mini"   v-if="scope.row.pass=='2' || scope.row.pass=='3' || scope.row.parts_no==''"   @click="delus(scope.row)">删除</el-button>
            <el-button type="primary" plain  size="mini"   v-if="scope.row.pass=='5' &&(scope.row.parts_no!='' || scope.row.pingkey!='' ) && dl_type=='-1'"   @click="del(scope.row.agentid)">签约</el-button>
          <!--  <el-button type="primary" plain  size="mini"   v-if="scope.row.pass=='5' &&scope.row.parts_no!='' && dl_type=='-1'"   @click="tpwxus(scope.row)">同步微信状态</el-button>-->
            <el-button type="primary" plain  size="mini"   v-if="(scope.row.pass=='5' || scope.row.pass=='2' || scope.row.pass=='0') && dl_type=='-1'"   @click="openUpgradeForm(scope.row)">驳回</el-button>
            <el-button type="primary" plain size="mini"    @click="openViewForm(scope.row)">详情</el-button>
            <el-button type="primary" plain size="mini"    v-if="scope.row.type=='' "  @click="openQyForm(scope.row)">纸质分账合同上传</el-button>
            <el-button type="primary" plain size="mini"    @click="openZkForm(scope.row)">设置商家折扣</el-button>
            <!--  <el-button type="primary" plain size="mini"     v-if="scope.row.pass=='5' && scope.row.parts_no=='' && (dl_type=='-1' || is_agentid=='7080007') " @click="wxjj(scope.row.agentid)">微信进件</el-button>-->
           <el-button type="primary" plain size="mini"     v-if="(scope.row.fws_type=='0' || scope.row.pingkey=='') && (dl_type=='-1' || is_agentid=='7080007') " @click="lswxjj(scope.row.agentid)">乐刷进件</el-button>

       </template>
     </el-table-column>

   </el-table>
   <template slot="footer">
     <el-pagination
       :current-page="page.current"
       :page-size="page.size"
       :total="page.total"
       :page-sizes="[1,10,50,100, 200, 300, 400]"
       layout="total, sizes, prev, pager, next, jumper"
       style="margin: -10px;"
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
     >
     </el-pagination>
   </template>
   <edit-form
     :agent="agent"
     :accuseVisible="accuseVisible"
     v-model="editFormVisible"
     @submit="getTableData"
   />
   <view-form
           :agent="agent"
           v-model="viewFormVisible"
           @submit="getTableData"
   />

   <upgrade-form
           :agent="agent"
           v-model="upgradeFormVisible"
           @submit="getTableData"
   />

    <qy-form
            :agent="agent"
            v-model="qyFormVisible"
            @submit="getTableData"
    />

    <zk-form
            :agent="agent"
            v-model="zkFormVisible"
            @submit="getTableData"
    />

 </d2-container>
</template>
<script>
import * as agentService from "@/api/sys/agent";
import editForm from "@/pages/sys/oldparts/editForm"
import viewForm from "./viewForm"
import util from '@/libs/util.js'
import upgradeForm from "./upgradeForm";
import qyForm from "./qyForm";
import zkForm from "./zkForm";
export default {
 name: "NewpartsPage",
 components: { editForm,viewForm ,upgradeForm,qyForm,zkForm},
 data() {
   return {
     searchForm: {
         userName: "",
       　oper_name: "",
         userCode: ""
     },
       bsOptions: [
           {
               value: "3",
               label: "未开通"
           },
           {
               value: "2",
               label: "待审核"
           },
           {
               value: "0",
               label: "已签约"
           },
           {
               value: "4",
               label: "签约失败"
           },
           {
               value: "5",
               label: "已提交微信进件、待微信审核"
           },
           {
               value: "6",
               label: "未微信进件"
           }
       ],
       zjOptions: [
           {
               value: "2",
               label: "企业"
           },
           {
               value: "1",
               label: "个体工商户"
           },
           {
               value: "300",
               label: "小微商户"
           }
       ],
       lsOptions: [
           {
               value: "3",
               label: "未进件"
           },
           {
               value: "0",
               label: "进件驳回"
           },
           {
               value: "1",
               label: "进件成功"
           },
           {
               value: "2",
               label: "进件审核中"
           }
       ],
     dateRange: [],
     pickerOptions:{},
       accuseVisible:true,
     loading: false,
     tableData: [],
     multipleSelection: [],
     page: {
       current: 1,
       size: 10,
       total: 0
     },
     sort: {
       prop: "",
       order: ""
     },
       agent: {},
     editFormVisible: false,
       dl_type:util.cookies.get('dl_type'),
       is_agentid:util.cookies.get('agentid'),
       upgradeFormVisible: false,
     qyFormVisible: false,
     zkFormVisible: false,
       viewFormVisible: false
   };
 },
 mounted() {
   this.getTableData();
 },
 methods: {
   getTableData() {
     let query = {
       pageIndex: this.page.current,
       pageSize: this.page.size,
       sortBy: this.sort.prop,
         agentid: util.cookies.get('agentid'),
         dl_type: util.cookies.get('dl_type'),
       start_time:this.dateConversion(this.dateRange[0]),
       end_time:this.dateConversion(this.dateRange[1]),
         xt_id:util.cookies.get('xt_id'),
         dl_type2:'4',
       descending: this.sort.order === "descending",
       filter: this.searchForm
     };
       agentService.getAgentPagedList(query).then(data => {
       this.tableData = data.rows;
       this.page.total = data.totalCount;
     });
   },
   dateConversion(value) {
     if (value != null && value != "") {
       var d = new Date(value);
       //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
       var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
       console.info("===========date=========" + date);
       return date;
     }else{
       return "";
     }
   },
   handleSearchFormSubmit() {
     this.getTableData();
   },
   handleSearchFormReset() {
     this.$refs.searchForm.resetFields();
   },
   handleSelectionChange(val) {
     this.multipleSelection = val;
   },
   handleSortChange(val) {
     this.sort.prop = val.prop;
     this.sort.order = val.order;
     this.getTableData();
   },
   handleSizeChange(val) {
     this.page.size = val;
     this.getTableData();
   },
   handleCurrentChange(val) {
     this.page.current = val;
     this.getTableData();
   },
   openEditForm(agent) {
         this.agent = agent;
         this.editFormVisible = false;
       this.accuseVisible=false;
       this.viewFormVisible = true;
     },
     wxjj(agentid) {
         let msg = "申请微信特约商户,提交后微信需要1-2天审核,申请后需要登陆服务商平台查看申请状态" ;
         this.$confirm("确认"+msg+"操作？", "确认信息", {
             distinguishCancelAndClose: true,
             confirmButtonText: "申请",
             cancelButtonText: "取消"
         }).then(() => {
             agentService.wxjj({agentid:agentid}).then(data => {

                 if(data==null || data=="" ) {
                     this.getTableData();
                 }

             });
         });
     },
     lswxjj(agentid) {
         let msg = "申请乐刷通道进件" ;
         this.$confirm("确认"+msg+"操作？", "确认信息", {
             distinguishCancelAndClose: true,
             confirmButtonText: "申请",
             cancelButtonText: "取消"
         }).then(() => {
             agentService.lswxjj({agentid:agentid}).then(data => {

                 if(data==null || data=="" ) {
                     this.getTableData();
                 }

             });
         });
     },
     delus(oneclass) {
         this.$confirm("确认删除？", "确认信息", {
             distinguishCancelAndClose: true,
             confirmButtonText: "删除",
             cancelButtonText: "取消"
         }).then(() => {
             agentService.delus({agentid:oneclass.agentid}).then(() => {
                 this.getTableData();
             });
         });
     },
     tpwxus(oneclass) {
         this.$confirm("确认同步？", "确认信息", {
             distinguishCancelAndClose: true,
             confirmButtonText: "确认",
             cancelButtonText: "取消"
         }).then(() => {
             agentService.tpwxus({agentid:oneclass.agentid}).then(() => {
                 this.getTableData();
             });
         });
     },
     openUpgradeForm(agent) {
         this.agent = agent;
         this.editFormVisible = false;
         this.viewFormVisible = false;
         this.accuseVisible = false;
         this.upgradeFormVisible = true;
     },
   openQyForm(agent) {
     this.agent = agent;
     this.editFormVisible = false;
     this.viewFormVisible = false;
     this.accuseVisible = false;
     this.upgradeFormVisible = false;
     this.qyFormVisible = true;
   },

   openZkForm(agent) {
     this.agent = agent;
     this.editFormVisible = false;
     this.viewFormVisible = false;
     this.accuseVisible = false;
     this.upgradeFormVisible = false;
     this.qyFormVisible = false;
     this.zkFormVisible = true;
   },
     openViewForm(agent) {
         this.agent = agent;
         this.editFormVisible = true;
         this.accuseVisible=false;
         this.viewFormVisible = false;
     },
   add() {
     this.agent = {};
     this.editFormVisible = true;
       this.accuseVisible=true;
   },
   reset(userId) {
       let msg = "重置密码";
       this.$confirm("确定要重置该帐号的密码吗？！重置后的密码为123456", "确认信息", {
           distinguishCancelAndClose: true,
           confirmButtonText: msg,
           cancelButtonText: "取消"
       }).then(() => {
           agentService.resetAgent({userId:userId}).then(() => {
               this.getTableData();
           });
       });
   },
   del(agentid) {
     this.$confirm("确认签约操作？", "确认信息", {
       distinguishCancelAndClose: true,
       confirmButtonText: "确认",
       cancelButtonText: "取消"
     }).then(() => {
         agentService.delAgent({agentid:agentid,type:0,sqcy:1,oper_name:util.cookies.get('oper_name')}).then(() => {
         this.getTableData();
       });
     });
   }
 }
};
</script>
